import { CELL_PLACEMENT_STATUS } from './cell-tire-rack-order'

interface StatusConfig {
  display: string
  backgroundColor: string
  statusColor: string
  textColor: string
}

const installationStatuses: { [key: string]: StatusConfig } = {
  completed: {
    display: 'Completed',
    backgroundColor: '#D9FBE7',
    statusColor: '#79E4A5',
    textColor: '#141414',
  },
  on_site: {
    display: 'On Site',
    backgroundColor: '#EBF0FF',
    statusColor: '#B5C8FF',
    textColor: '#141414',
  },
  started: {
    display: 'Started',
    backgroundColor: '#F5EAFF',
    statusColor: '#D7ABFF',
    textColor: '#141414',
  },
  en_route: {
    display: 'En Route',
    backgroundColor: '#E5F6FF',
    statusColor: '#A4DCFF',
    textColor: '#141414',
  },
  cancelled_onsite: {
    display: 'Cancelled Onsite',
    backgroundColor: '#EEEEEE',
    statusColor: '#CECECE',
    textColor: '#141414',
  },
  cancelled: {
    display: 'Cancelled',
    backgroundColor: '#EEEEEE',
    statusColor: '#CECECE',
    textColor: '#141414',
  },
  almost_late: {
    display: 'Almost Late',
    backgroundColor: '#F9F3CD',
    statusColor: '#EFDA4D',
    textColor: '#141414',
  },
  late: {
    display: 'Late',
    backgroundColor: '#FFE2E2',
    statusColor: '#FD9191',
    textColor: '#141414',
  },
  technician_not_available: {
    display: 'Tech Not Available',
    backgroundColor: '#FFE8D1',
    statusColor: '#FFB76E',
    textColor: '#141414',
  },
  scheduled: {
    display: 'Scheduled',
    backgroundColor: '#FFFFFF',
    statusColor: '#141414',
    textColor: '#FFFFFF',
  },
  pending_rescheduling: {
    display: 'Pending Rescheduling',
    backgroundColor: '#FFFFFF',
    statusColor: '#141414',
    textColor: '#FFFFFF',
  },
  fixed: {
    display: 'Fixed',
    backgroundColor: 'none',
    statusColor: '#EEEEEE',
    textColor: '#141414',
  },
}

const deliveryStatuses: { [key: string]: StatusConfig } = {
  completed: {
    display: 'Delivered',
    backgroundColor: '#D9FBE7',
    statusColor: '#79E4A5',
    textColor: '#141414',
  },
  on_site: {
    display: 'Arrived',
    backgroundColor: '#EBF0FF',
    statusColor: '#B5C8FF',
    textColor: '#141414',
  },
  started: {
    display: 'Arrived',
    backgroundColor: '#F5EAFF',
    statusColor: '#D7ABFF',
    textColor: '#141414',
  },
  en_route: {
    display: 'Out for Delivery',
    backgroundColor: '#E5F6FF',
    statusColor: '#A4DCFF',
    textColor: '#141414',
  },
  cancelled_onsite: {
    display: 'Delivery Cancelled',
    backgroundColor: '#EEEEEE',
    statusColor: '#CECECE',
    textColor: '#141414',
  },
  cancelled: {
    display: 'Delivery Cancelled',
    backgroundColor: '#EEEEEE',
    statusColor: '#CECECE',
    textColor: '#141414',
  },
  almost_late: {
    display: 'Out for Delivery',
    backgroundColor: '#F9F3CD',
    statusColor: '#EFDA4D',
    textColor: '#141414',
  },
  late: {
    display: 'Out for Delivery',
    backgroundColor: '#FFE2E2',
    statusColor: '#FD9191',
    textColor: '#141414',
  },
  technician_not_available: {
    display: 'Driver Not Available',
    backgroundColor: '#FFE8D1',
    statusColor: '#FFB76E',
    textColor: '#141414',
  },
  scheduled: {
    display: 'Delivery',
    backgroundColor: '#FFFFFF',
    statusColor: '#141414',
    textColor: '#FFFFFF',
  },
  pending_rescheduling: {
    display: 'Delivery Needs Rescheduling',
    backgroundColor: '#FFFFFF',
    statusColor: '#141414',
    textColor: '#FFFFFF',
  },
  fixed: {
    display: 'Fixed',
    backgroundColor: 'none',
    statusColor: '#EEEEEE',
    textColor: '#141414',
  },
}

const cellPlacementStatuses: { [key in CELL_PLACEMENT_STATUS]: StatusConfig } =
  {
    [CELL_PLACEMENT_STATUS.ALL_PLACED]: {
      display: 'All Placed',
      backgroundColor: '#D9FBE7',
      statusColor: '#79E4A5',
      textColor: '#141414',
    },
    [CELL_PLACEMENT_STATUS.UNDERLOADED]: {
      display: 'Underloaded',
      backgroundColor: '#EBF0FF',
      statusColor: '#B5C8FF',
      textColor: '#141414',
    },
    [CELL_PLACEMENT_STATUS.OVERLOADED]: {
      display: 'Overloaded',
      backgroundColor: '#FFE2E2',
      statusColor: '#FD9191',
      textColor: '#141414',
    },
    [CELL_PLACEMENT_STATUS.ZERO_PLACED]: {
      display: 'Zero Placed',
      backgroundColor: '#FFFFFF',
      statusColor: '#141414',
      textColor: '#FFFFFF',
    },
  }

export { installationStatuses, deliveryStatuses, cellPlacementStatuses }
